<gatewee-drawer
  *ngIf="usePageDrawer"
  [open]="pageDrawerOpen"
  (openChange)="onPageDrawerOpenChange($event)"
  [showHeaderTitle]="true"
  [title]="drawerTitleKey | translate"
  [showBackButton]="true"
  [backButtonLabel]="'common.actions.back' | translate"
  (backClick)="handleShellBack()"
  [closeButtonLabel]="'common.close' | translate"
>
  <ng-container *ngTemplateOutlet="bankSlipShell"></ng-container>
  <footer *ngIf="activeFlow === 'form'">
    <ng-container *ngIf="paymentForm?.actionFooterTpl as footTpl">
      <ng-container *ngTemplateOutlet="footTpl"></ng-container>
    </ng-container>
  </footer>
</gatewee-drawer>

<ng-container *ngIf="!usePageDrawer">
  <ng-container *ngTemplateOutlet="bankSlipShell"></ng-container>
</ng-container>

<ng-template #bankSlipShell>
  <div
    class="gw-overflow-hidden"
    [class.gw-flex]="usePageDrawer"
    [class.gw-h-full]="usePageDrawer"
    [class.gw-min-h-0]="usePageDrawer"
    [class.gw-flex-col]="usePageDrawer"
  >
    <div
      class="gw-w-full bank-slip-step-viewport bank-slip-step-stack"
      [class.gw-min-h-0]="usePageDrawer"
      [class.gw-flex-1]="usePageDrawer"
      [class.gw-flex]="usePageDrawer"
      [class.gw-flex-col]="usePageDrawer"
    >
      <div
        class="gw-min-w-0 gw-box-border bank-slip-step-pane"
        [class.gw-flex]="usePageDrawer"
        [class.gw-min-h-0]="usePageDrawer"
        [class.gw-flex-1]="usePageDrawer"
        [class.gw-flex-col]="usePageDrawer"
        [class.bank-slip-step-pane--visible]="activeFlow === 'form'"
      >
        <app-bank-slip-payment-form
          #paymentForm
          [flowActive]="activeFlow === 'form'"
          [shellKind]="usePageDrawer ? 'pageDrawer' : 'dialog'"
          [feeSnapshot]="feeSnapshot"
          [walletId]="effectiveWalletId"
          [walletAvailableBalance]="walletAvailableBalance"
          (scanRequested)="openScanner()"
          (completed)="onPaymentCompleted()"
          (embeddedTitleKeyChange)="onFormShellChange()"
          (shellFooterChange)="onFormShellChange()"
        ></app-bank-slip-payment-form>
      </div>

      <div
        class="gw-min-w-0 gw-box-border bank-slip-step-pane"
        [class.gw-flex]="usePageDrawer"
        [class.gw-min-h-0]="usePageDrawer"
        [class.gw-flex-1]="usePageDrawer"
        [class.gw-flex-col]="usePageDrawer"
        [class.bank-slip-step-pane--visible]="activeFlow === 'scanner'"
      >
        <app-qr-scanner-pane
          #scannerRef
          [active]="activeFlow === 'scanner'"
          [titleKey]="'features.withdrawals.modalBankSlip.scannerTitle'"
          [permissionDeniedKey]="
            'features.withdrawals.modalBankSlip.scannerPermissionDenied'
          "
          (qrDetected)="onScannerDetected($event)"
        ></app-qr-scanner-pane>
      </div>
    </div>
  </div>
</ng-template>
